const _temp0 = require("url:../assets/flyers/summer-tour.webp");
module.exports = {
  "summer-tour": _temp0
}